/**
 * Product card interactions: swatches and collection quick-add (AJAX cart).
 */

document.addEventListener("click", (e) => {
  const swatch = e.target.closest("[data-swatch]");
  if (!swatch) return;

  e.preventDefault();
  e.stopPropagation();

  const card = swatch.closest("[data-product-card]");
  if (!card) return;

  const img = card.querySelector(".product-card-image");
  if (img && swatch.dataset.imageSrc) {
    img.src = swatch.dataset.imageSrc;
    if (swatch.dataset.imageSrcset) {
      img.srcset = swatch.dataset.imageSrcset;
    }
  }

  if (swatch.dataset.url) {
    card.querySelectorAll("a").forEach((a) => {
      a.href = swatch.dataset.url;
    });
  }

  card.querySelectorAll("[data-swatch]").forEach((s) => {
    s.classList.remove("ring-2", "ring-offset-1", "ring-gray-900");
  });
  swatch.classList.add("ring-2", "ring-offset-1", "ring-gray-900");
});

document.addEventListener("submit", async (e) => {
  const form = e.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.closest("[data-product-card]")) return;
  const quickBtn = form.querySelector("[data-card-quick-add]");
  if (!quickBtn || !(quickBtn instanceof HTMLButtonElement)) return;

  e.preventDefault();

  const strip = form.querySelector("[data-card-quick-strip]");
  const stripHtml = strip ? strip.innerHTML : null;

  quickBtn.disabled = true;
  quickBtn.setAttribute("aria-busy", "true");
  if (strip) {
    strip.innerHTML =
      '<span class="min-w-0">Adding\u2026</span><span class="opacity-60" aria-hidden="true">\u2014</span>';
  }

  try {
    const body = new FormData(form);
    const response = await fetch("/cart/add.js", {
      method: "POST",
      body,
    });

    if (!response.ok) {
      throw new Error(`Add failed: ${response.status}`);
    }

    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();
    document.dispatchEvent(
      new CustomEvent("cart:updated", { detail: { item_count: cart.item_count } }),
    );
    document.dispatchEvent(new CustomEvent("cart:open"));

    const status = document.getElementById("cart-status");
    if (status) {
      status.textContent = "Added to bag.";
    }

    if (strip) {
      strip.innerHTML =
        '<span class="min-w-0">Added</span><span class="opacity-60" aria-hidden="true">\u2014</span>';
    }

    await new Promise((r) => setTimeout(r, 900));

    if (strip && stripHtml != null) {
      strip.innerHTML = stripHtml;
    }

    quickBtn.disabled = false;
    quickBtn.removeAttribute("aria-busy");
  } catch (err) {
    console.error("[product-card]", err);

    if (strip) {
      strip.innerHTML =
        '<span class="min-w-0">Error</span><span class="opacity-60" aria-hidden="true">\u2014</span>';
    }

    quickBtn.disabled = false;
    quickBtn.removeAttribute("aria-busy");

    await new Promise((r) => setTimeout(r, 1800));

    if (strip && stripHtml != null) {
      strip.innerHTML = stripHtml;
    }
  }
});
